import script from "./slack-emoji-zip.vue?vue&type=script&setup=true&lang=js"
export * from "./slack-emoji-zip.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__